import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input()
  isActive: boolean = false;
  @Input()
  withOverlay: boolean = true;
  @Input()
  isBalls: boolean = true;
  @Input()
  withText: boolean = true;
  @Input()
  isSmall: boolean = false;
  @Input()
  isSmallSpinner: boolean = false;
  @Input()
  isAbsolute: boolean = false;

  constructor() {}

  ngOnInit() {}
}
